import { useState } from 'react'
import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { AutoComplete } from 'antd'
import { SelectValue } from 'antd/es/select'
import { Select } from 'components/Select'
import { useAppSelector } from 'store'
import { isEmpty } from 'utils/is-empty'

export const TradingAccountBrokerSymbolFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const symbols = useAppSelector((state) => state.tradingAccounts.instruments)

  const [selectedBrokerSymbols, setSelectedBrokerSymbols] = useState<SelectValue>([])
  const selectValue = filter.value ?? selectedBrokerSymbols

  return (
    <Select
      showSearch
      placeholder='Broker Symbol'
      value={selectValue}
      onChange={(value: SelectValue) => {
        if (isEmpty(value)) {
          setSelectedBrokerSymbols([])
          onFilterChange.call(undefined, { nextFilter: { ...filter, value: null } })
        } else {
          setSelectedBrokerSymbols(value)
          onFilterChange.call(undefined, { nextFilter: { ...filter, value } })
        }
      }}
      style={{ width: '250px' }}
    >
      {symbols.map(({ symbol }) => (
        <AutoComplete.Option value={symbol} key={symbol}>
          {symbol}
        </AutoComplete.Option>
      ))}
    </Select>
  )
}
